import { render, staticRenderFns } from "./fields-privilege.vue?vue&type=template&id=0083d20f&scoped=true&"
import script from "./fields-privilege.vue?vue&type=script&lang=js&"
export * from "./fields-privilege.vue?vue&type=script&lang=js&"
import style0 from "./fields-privilege.vue?vue&type=style&index=0&id=0083d20f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0083d20f",
  null
  
)

export default component.exports